import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.362 5.012c1.94-.15 3.72 1.185 4.148 3.179l.249 1.161 1.102-.443a2.954 2.954 0 012.809.33A3.17 3.17 0 0120 11.847v.004c0 1.473-.974 2.69-2.264 3.043a1 1 0 10.528 1.93c2.165-.593 3.735-2.604 3.736-4.97A5.169 5.169 0 0019.82 7.6a4.96 4.96 0 00-3.663-.84c-.959-2.382-3.33-3.946-5.949-3.744-2.744.213-4.933 2.3-5.403 4.98-1.878.807-3.026 2.805-2.77 4.898.226 1.84 1.482 3.332 3.153 3.88a1 1 0 00.624-1.9c-.932-.306-1.66-1.151-1.791-2.224-.168-1.37.69-2.621 1.95-2.945l.703-.18.047-.725c.13-2.041 1.7-3.64 3.641-3.79zM10.945 21a1 1 0 102 0v-6.59l1.3 1.3a1 1 0 001.4-1.42l-3-3a1 1 0 00-1.4 0l-3 3a1 1 0 001.4 1.42l1.3-1.3V21z",
      fill: "#2d6ded"
    }
  )
), t = a;
export {
  t as default
};
